export const get = (storage, key) => {
  const val = storage.getItem(key)
  if (val === null) return undefined
  try {
    return JSON.parse(val)
  } catch (e) {
    storage.removeItem(key) // Prevent permanently broken app
    throw e // But still throw as this is unhandled exception
  }
}

export const set = (storage, key, value) => {
  if (!value) return storage.removeItem(key)
  return storage.setItem(key, JSON.stringify(value))
}
